import { render, staticRenderFns } from "./ShareBoardModal.vue?vue&type=template&id=84162c4c"
import script from "./ShareBoardModal.vue?vue&type=script&lang=js"
export * from "./ShareBoardModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports